<p-dropdown *ngIf="editable"
            name="selectedPdfTemplate" [placeholder]="Validation.DropdownPlaceholder" [filter]="true" filterBy="label" [showClear]="true"
            [style]="{'width':'215px'}"
            [(ngModel)]="selectedPdfTemplate" [options]="pdfTemplates"
            (onChange)="onSelectPdfTemplate(selectedPdfTemplate)"
            [disabled]="disabled" [readonly]="readonly">
  <ng-template let-pdfTemplate pTemplate="item">
    <div>
      {{pdfTemplate.label}}
    </div>
  </ng-template>
</p-dropdown>

<div *ngIf="!editable&&selectedPdfTemplate" style="position: relative;top:-7px;">
  {{selectedPdfTemplate.name}}
</div>
